import { useQuery } from "@apollo/client"
import { GAME_LIST } from "../queries/gameList"

export interface GameListItem {
  id: number
  name: string
  availables: number
}

export interface GameListInput {
  storeId: number
}

export const useGameList = (input: GameListInput) => {
  const { data, loading, error, refetch } = useQuery<{
    GameList: {
      status: {
        success: boolean
        name: string
        detail: string
      }
      Games: GameListItem[]
    }
  }>(GAME_LIST, {
    variables: { GameListInput: input },
    errorPolicy: "all",
  })

  return {
    games: data?.GameList?.Games || [],
    status: data?.GameList?.status,
    loading,
    error,
    refetch,
  }
}
